import ArchetypeExplorer from './ArchetypeExplorer'

export default ArchetypeExplorer
// eslint-disable-next-line import/export
export * from './ArchetypeExplorer'
